import {
  GET_LIST_KIEMKHO,
  GET_LIST_KIEMKHO_SUCCESS,
  GET_LIST_KIEMKHO_FAILURE,
  UPDATE_SEARCHTDATA_KIEMKHO,
} from "./actionTypes";

export const getListKiemKho = (dataSearch) => ({
  type: GET_LIST_KIEMKHO,
  dataSearch,
});
export const getListKiemKhoSuccess = (data) => ({
  type: GET_LIST_KIEMKHO_SUCCESS,
  payload: data,
});
export const getListKiemKhoFailure = (dataSearch) => ({
  type: GET_LIST_KIEMKHO_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_KIEMKHO,
  payload: data,
});
